import ServiceBase from '@/Services/ServiceBase';

export default class LocationsService extends ServiceBase {
    getLocations() {
        return this.request('get', '/locations', null);
    }
}